import JobsTableLayout from "@/pages/_layouts/jobs/JobsTableLayout";
import { useParams } from "react-router-dom";

export default function AllJobsPage() {
  const { facilityId } = useParams();

  return (
    <JobsTableLayout
      firstUnderTabs="entity-detail"
      columnHeaders={{
        title: true,
        facility: false,
        serviceLevel: true,
        totalCompensation: false,
        employer: true,
        owner: false,
        postedOn: true,
        submissionDeadline: true,
        applicantCount: true,
        postingStage: true,
        jobStatus: true,
        section: false
      }}
      filters={{
        postingStage: true,
        jobStatus: true,
        serviceLevel: true,
        postedDateRange: true,
        section: false,
        owner: false
      }}
      defaultValues={{
        facilityId: facilityId,
        stage: []
      }}
      defaultSort={[{ id: "goLiveTime", desc: true }]}
    />
  );
}
